import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { indexServers } from "../http/ServerAPI";
import { usePollingData } from "../hooks/usePollingData";
import { useNavigate } from "react-router-dom";
import { Container, Typography, Box, Grid, Button } from "@mui/material";
import AddCircle from "@mui/icons-material/AddCircle";
import BreadCrumbs from "../components/Breadcrumbs";
import { Context } from "../index";
import ServerCard from "../components/ServerCard";
import { CREATE_SERVER } from "../utils/consts";

const Servers = observer(() => {
    const navigate = useNavigate();
    const { user } = useContext(Context);
    const { data: servers = [], reload: loadServers } = usePollingData(indexServers, {
        initialData: [],
        intervalMs: 30000,
        onSuccess: (data) => user.setServers(data),
        errorMessage: "Ошибка загрузки серверов",
    });

    return (
        <Container maxWidth="xl">
            <Box mt={3}>
                <BreadCrumbs hrefs="" name="Список серверов" />
            </Box>
            <Box mt={3} display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h4">Сервера</Typography>
                <Button variant="contained" startIcon={<AddCircle />} onClick={() => navigate(CREATE_SERVER)}>
                    Создать сервер
                </Button>
            </Box>
            <Grid container spacing={2} mt={2}>
                {servers.map(server => (
                    <Grid item xs={12} sm={6} md={4} key={server.server_id}>
                        <ServerCard server={server} refreshServers={loadServers} />
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
});

export default Servers;
